const SOCReducer = (state = {}, action) => {
    switch (action.type) {
      case "SOC_LISTVIEW":
        return Object.assign({}, state, {
          SOC_ListView: action.data
        });
      case "SOCEDIT_DOCS":
        return Object.assign({}, state, {
          geteditsoc: action.data
        });
  
      case "SHARE_SOCDATAS":
        return Object.assign({}, state, {
          sharedsocdata: action.data
        });
        case "SHARE_SOCFILES":
          return Object.assign({}, state, {
            sharedsocfiles: action.data
          });
      case "ERROR_SOCDATAS":
        return Object.assign({}, state, {
          errorsocpass: action.data
        });
        case "DEFAULT_SOCDATAS":
        return Object.assign({}, state, {
          defaultsoc: action.data
        });
        
      default:
        return state;
    }
  };
  
  export default SOCReducer;